var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPerson = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M6.25 4.5a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0M3.75 12c0-.69.56-1.25 1.25-1.25h6c.69 0 1.25.56 1.25 1.25v2a.75.75 0 0 0 1.5 0v-2A2.75 2.75 0 0 0 11 9.25H5A2.75 2.75 0 0 0 2.25 12v2a.75.75 0 0 0 1.5 0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPerson);
export default ForwardRef;